import {
  ACHeatBold,
  AllowancesSmokingBold,
  AsianInteriorEatingTableBold,
  BathroomShowerBold,
  CarGarageBold,
  ConcertGuitaristBold,
  ConsoleLampBold,
  DisabilityWheelchair1Bold,
  DishwasherBold,
  DoorLockBold,
  DressingHanger1Bold,
  DryerBold,
  GridArtboardBold,
  HeaterBold,
  HotelDoubleBed1Bold,
  KitchenKnifeSetBold,
  KitchenShelfBold,
  LaundryMachine2Bold,
  ModernTVFlatScreenBold,
  PetsPawBold,
  PlantFlowersBold,
  RouterSignal1Bold,
  SofaDoubleBold,
  StairsDescendBold,
  ToiletSeatBold,
  OfficeTableLight,
} from '@ha/icons';
import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid } from '@hbf/dsl';
import { FacilitiesValues } from 'ha/models/ListingFacilities/constants';
import { FacilitiesDetailsTranslations } from 'ha/models/ListingFacilities/translations';

import { ListingFacilities } from '@ha/api/v2/types/Listing';

const facilitiesIcons = {
  flooring: GridArtboardBold,
  parking: CarGarageBold,
  toilet: ToiletSeatBold,
  basement: StairsDescendBold,
  living_room: SofaDoubleBold,
  wifi: RouterSignal1Bold,
  tv: ModernTVFlatScreenBold,
  garden: PlantFlowersBold,
  kitchenware: KitchenShelfBold,
  kitchen: KitchenKnifeSetBold,
  dishwasher: DishwasherBold,
  bed: HotelDoubleBed1Bold,
  closet: DressingHanger1Bold,
  heating: HeaterBold,
  bathroom: BathroomShowerBold,
  lock: DoorLockBold,
  wheelchair_accessible: DisabilityWheelchair1Bold,
  lroom_furniture: ConsoleLampBold,
  ac: ACHeatBold,
  dryer: DryerBold,
  balcony_terrace: AsianInteriorEatingTableBold,
  washing_machine: LaundryMachine2Bold,
  play_music: ConcertGuitaristBold,
  animal_allowed: PetsPawBold,
  smoking_allowed: AllowancesSmokingBold,
  desk: OfficeTableLight,
};

interface Props {
  facilities: Partial<ListingFacilities>;
}

const useStyles = makeStyles()((theme: Theme) => ({
  icon: {
    fontSize: theme.spacing(3),
    marginRight: theme.spacing(1.5),
    verticalAlign: 'middle',
  },
  availableFacilities: {
    color: theme.palette.secondary.main,
  },
  facilitiesWithNo: {
    color: theme.palette.grey[500],
  },
}));

const ListingFacilityGroup: React.FC<Props> = ({ facilities }) => {
  const { T } = useIntl();
  const { classes, cx } = useStyles();

  const getFacilityIcon = (name: string, iconColor: string) => {
    const FacilityIcon = facilitiesIcons[name];

    return <FacilityIcon className={cx(classes.icon, iconColor)} />;
  };

  return (
    <React.Fragment>
      {Object.entries(facilities).map(([name, value]) => (
        <Grid
          item
          xs={12}
          md={4}
          key={name}
          data-test-locator={`Listing/ListingFacilitiesSection/Facility/${name}`}
        >
          <Grid container>
            <Grid item xs="auto" md={2}>
              {getFacilityIcon(
                name,
                value === FacilitiesValues.No
                  ? classes.facilitiesWithNo
                  : classes.availableFacilities,
              )}
            </Grid>
            <Grid item xs={10} md={10}>
              {T(FacilitiesDetailsTranslations[name][value])}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </React.Fragment>
  );
};

export { ListingFacilityGroup };
